import { Link, useLocation } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { COMPANY } from "../../data/content";

const MobileCTA = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin") || pathname === "/contact") return null;
  return (
    <div data-testid="mobile-cta" className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-black/10 md:hidden">
      <a
        href={COMPANY.phoneHref}
        data-testid="mobile-cta-phone"
        className="flex items-center justify-center gap-2 bg-bati-ink py-4 text-[13px] font-bold uppercase tracking-[0.1em] text-white"
      >
        <Phone className="h-4 w-4" /> Appeler
      </a>
      <Link
        to="/contact"
        data-testid="mobile-cta-devis"
        className="flex items-center justify-center gap-2 bg-bati-blue py-4 text-[13px] font-bold uppercase tracking-[0.1em] text-white"
      >
        <FileText className="h-4 w-4" /> Devis gratuit
      </Link>
    </div>
  );
};

export default MobileCTA;
